/* LOSEFORD 再入荷通知（第4段階）
 *
 * 在庫切れのバリアントが選ばれているときだけ、再入荷の導線を出す。
 *
 * Impulse はバリアントを切り替えるたびに商品フォームの中身を描き直すが、
 * この枠はフォームの外にあるため、こちらで在庫の有無を見て出し分ける。
 * 在庫のあるバリアントIDは Liquid 側が data 属性で渡している。
 */
(function () {
  'use strict';

  function boot(root) {
    var box = (root || document).querySelector('[data-lf-restock]');
    if (!box || box.dataset.lfRestockReady === '1') return;
    box.dataset.lfRestockReady = '1';

    // 「12345,67890,」の形で渡ってくる。末尾の空要素は捨てる。
    var inStock = (box.getAttribute('data-lf-restock-available') || '')
      .split(',')
      .filter(function (s) { return s !== ''; });

    function currentVariantId() {
      // Impulse はフォーム内の hidden input に選択中のIDを持つ
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      // 取れないときは URL の ?variant= を見る
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : '';
    }

    function sync() {
      var id = currentVariantId();
      // IDが取れないときは触らない。誤って出すより出さないほうが安全。
      if (!id) return;
      var available = inStock.indexOf(id) !== -1;
      if (available) {
        box.setAttribute('hidden', '');
        box.removeAttribute('data-lf-restock-open');
      } else {
        box.removeAttribute('hidden');
        box.setAttribute('data-lf-restock-open', '');
      }
    }

    sync();

    // バリアントの切り替えを拾う。Impulse の独自イベントと
    // 素の change の両方を見ておく（テンプレートによって出る側が違う）。
    document.addEventListener('variantChange', sync);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        // 描き直しの直後に読むため、1フレーム待つ
        window.setTimeout(sync, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // テーマエディタでセクションを編集し直したときにも効かせる
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
